import { Component, OnInit, Inject, Compiler } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { MacroService } from '../../shared/services/macro.service';
import { AlertaService } from '../../alerta/alerta.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-session-iniciar',
  templateUrl: './sessioniniciar.component.html',
  styleUrls: ['../../app.component.css', './sessioniniciar.component.css']
})

export class SessionIniciarComponent implements OnInit {

  user;
  pass;
  public loading = false;

  constructor(
    @Inject(AlertaService) private servicioAlerta: AlertaService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    @Inject(MacroService) public macroService: MacroService,
    private router:Router, private _compiler: Compiler) { }

  ngOnInit() {
    const token = this.storage.get("idma");
    const reload = this.storage.get("reload");
    if(reload !== null){
      this.storage.set("reload", null);
      window.location.reload();
      this._compiler.clearCache();
      return;
    }
    if(token!==null && token !== undefined){
      this.router.navigate(['actividades/por-formulario']);
    }
  }

  inicioSession() {
    this.servicioAlerta.limpiarMensajes();
    if (this.user === undefined || this.user.length === 0 ||
      this.pass === undefined || this.pass.length === 0) {
      this.servicioAlerta.errorMensaje("llene el usuario y la clave por favor.");
      return;
    }

    let verificacion = {
      nombreUsuario: this.user,
      factor: this.pass
    }
    this.loading = true;
    this.macroService.crearFactor(verificacion).subscribe(
      info => {
        this.verificarCredenciales(info);
        this.loading = false;
      }, err => {
        this.controlarError(err);
        this.loading = false;
      });
  }

  private verificarCredenciales(verificacion: { nombreUsuario: any; factor: any; }) {
    this.loading = true;
    this.macroService.verificarCredenciales(verificacion).subscribe(data => {
      const usuario = data;
      if (usuario.multisesion === "true" || usuario.crm === "true") {
        this.storage.set("idem", usuario.idempresa);
        this.storage.set("nmper", usuario.nombresperfil);
        this.storage.set("uinvi", usuario.usuarioinvitado);
        this.storage.set("nmus", usuario.idusuario);
        this.storage.set("nomus", usuario.nombreusuario);
        this.storage.set("asocem", usuario.empresasasociadas);
        const sesion = { idusuario: usuario.idusuario };
        this.storage.set("crm", usuario.crm === 'true' ? true : false);       
        if (usuario.multisesion === "true") {
          this.crearSession(sesion, usuario.multisesion);
        } else {
          this.crearSessionCloud(sesion);
        }
        this.loading = false;
      } else {
        this.servicioAlerta.advertencia('Usuario no válido para esta plataforma.');
        return;
      }
      
    }, err => {
      this.servicioAlerta.errorMensaje("Verificar usuario/credenciales");
      this.loading = false;
    });
  }
	
  private crearSessionCloud(sesion: any) {
    this.loading = true;
    this.macroService.crearSessionCloud(sesion).subscribe(
      info => {
        this.storage.set("idma", info.token);
				this.consultarUsuario(Number(sesion.idusuario));
        this.router.navigate(['actividades/por-formulario']);
        this.loading = false;
      }, err => {
        this.controlarError(err);
        this.loading = false;
      });
  }

  private crearSession(sesion: any, multisesion: string) {
    this.loading = true;
    sesion.iddispositivo = 1;
    this.macroService.crearSession(sesion).subscribe(
      info => {
        this.storage.set("idma", info.token);
				this.consultarUsuario(Number(sesion.idusuario));
        this.router.navigate(['actividades/por-formulario']);
        this.loading = false;
      }, err => {
        this.controlarError(err);
        this.loading = false;
      });
  }

	private consultarUsuario(id_usaurio: number) {
		this.macroService.consultarUsuario(id_usaurio).subscribe(data => {
			this.storage.set("nsgusr", data.nombressegmentos);
		}, err => {
			console.error(err);
		});
	}

  controlarError(error: any) {
    this.servicioAlerta.error(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/session/iniciar/sessioniniciar.component.ts